import { AnalyticsTagDirectiveException } from '../errors/analytics-error';
import { hasTaggingType, TAGGING_TYPES_ARRAY } from '../models/tagging-types';
import TagUtils from './tag-utils';

/**
 * Tag Directive
 * @module v-tag
 */
/**
 * Vue Tag directive declaration.
 */
export const tag = {
  name: 'tag',
  inserted: (el, binding) => {
    const { arg, value: data = {}, modifiers } = binding;
    let eventType = 'click';

    if (!arg) {
      throw new AnalyticsTagDirectiveException(
        `No argument given to v-tag. Example usage: v-tag:event="{category: 'video', action: 'play', label: 'video.mp4'}}". Argument options: ${TAGGING_TYPES_ARRAY.join(', ').toLowerCase()}`,
      );
    }

    if (!hasTaggingType(arg)) {
      throw new AnalyticsTagDirectiveException(
        `v-tag argument [${arg}] to v-tag is wrong. Argument options: ${TAGGING_TYPES_ARRAY.join(', ').toLowerCase()}`,
      );
    }

    switch (arg) {
      case 'productimpression':
        data.type = 'productImpression';
        eventType = 'impression';
        break;

      case 'productdetail':
        data.type = 'productDetail';
        eventType = 'detail';
        break;

      case 'productclick':
        data.type = 'productClick';
        break;

      case 'promotionclick':
        data.type = 'promotionClick';
        break;

      case 'promotionimpression':
        data.type = 'promotionImpression';
        eventType = 'impression';
        break;
      default:
        data.type = 'userActionEvent';
        eventType = modifiers.onload ? 'impression' : eventType;
        break;
    }

    function checkBreakpoint() {
      if (arg === 'useractionevent' && data.category === 'main menu') {
        const isMobile = window.matchMedia('only screen and (max-width: 1024px)').matches;
        const headerEventName = isMobile ? 'burger menu' : 'header';
        data.action = `select::${headerEventName}`;
        data.click_area = headerEventName;
      }
    }

    checkBreakpoint();
    window.addEventListener('resize', checkBreakpoint);

    TagUtils.handleEvent(eventType, el, data, 'dom' in binding.modifiers);
  },
};
